export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/service-provider/profile/personal-info', 'service-provider.personal-info')
    .when('/service-provider/profile/experience', 'service-provider.personal-experience')
    .when('/service-provider/profile/verification', 'service-provider.verification-info')
    .when('/service-provider/profile/active-insurance', 'service-provider.active-insurance')
    .when('/service-provider/profile/public', 'service-provider.public-profile')

    .within('service-provider')

    .segment('personal-info', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.profile'
      }],
      template: '<service-provider-personal-info-page></service-provider-personal-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-personal-info.module" */ "./personal-info/service-provider-personal-info.module");
      }
    })

    .segment('personal-experience', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.profile'
      }],
      template: '<service-provider-personal-experience-page></service-provider-personal-experience-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-personal-experience.module" */ "./personal-experience/service-provider-personal-experience.module");
      }
    })

    .segment('verification-info', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.profile'
      }],
      template: '<service-provider-verification-info-page></service-provider-verification-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-verification-info.module" */ "./verification-info/service-provider-verification-info.module");
      }
    })

    .segment('active-insurance', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.profile'
      }],
      template: '<service-provider-active-insurance-page></service-provider-active-insurance-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-active-insurance.module" */ "./active-insurance/service-provider-active-insurance.module");
      }
    })

    .segment('public-profile', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [
        {
          label: 'service_provider.breadcrumb.profile',
          url: '/service-provider/profile/verification'
        },
        {
          label: 'service_provider.breadcrumb.public_profile'
        }
      ],
      template: '<service-provider-public-profile-page></service-provider-public-profile-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-public-profile.module" */ "./public-profile/service-provider-public-profile.module");
      }
    });
}
